import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import DataTable from '../core/components/datatable/DataTable';
import { useComponentDidMount } from '../core/hooks';
import { unixToDateTimeString } from '../core/utils/date';
import {
  orderActions,
  OrderStore,
} from '../orders/store/orders/orderStore';
import { urlSelector } from 'lib/functions';

interface ClientOrdersProps {
  clientId: string,
  orderStore?: OrderStore,
}

const ClientOrders = (props: ClientOrdersProps) => {
  const {
    orderStore,
    clientId,
  } = props;

  const { clientOrders, clientOrdersByClientId } = orderStore;

  const [loading, setLoading] = useState(false);

  const columns = [
    { 
      title: 'Номер заявки',
      name: 'number',
      getCellValue: (row) => <Link to={ `${ urlSelector(row.serviceId) }/${ row.id }` }>{ row.number }</Link>,
    },
    { title: 'Дата, время заявки', name: 'createdAt', getCellValue: (row, cell) => unixToDateTimeString(row[cell]) },
    { title: 'Статус заявки', name: 'statusRefValueName' },
    { title: 'Сервис', name: 'serviceName' },
    { title: 'Партнер', name: 'partnerName' },
  ];

  const loadData = async (request:string) => {
    setLoading(true);
    orderActions.getOrdersByClient(request);
    setLoading(false);
  };

  useComponentDidMount(() => {
    if (clientOrdersByClientId !== clientId) { loadData(clientId); }
  });

  return (
    <Col md={ 12 }>
      <Row>
        { (clientOrdersByClientId === clientId)
        && (
          <Col md={ 12 }>
            <DataTable
              loading={ loading }
              data={ clientOrders || [] }
              columns={ columns }
              localPaging
              localSorting
              hideToolbar
            />
          </Col>
        ) }
      </Row>
    </Col>
  );
};

export default inject('orderStore')(observer(ClientOrders));
